import { Select, useTransformSelectValue } from '@sbv-clients/ui-shared';

import useAutoSelectValue from './util/use-auto-select-value';

const options = [
  { id: '0', label: 'No', value: 0 },
  { id: '1', label: 'Yes', value: 1 },
];

export function DisplayTotalsFilter({
  autoSelectIfEmpty = false,
  useContextFn,
  errorMessages = {},
}: {
  autoSelectIfEmpty?: boolean;
  useContextFn: () => {
    displayTotals: number;
    onChangeDisplayTotals: (value: number) => void;
  };
  errorMessages?: Record<string, string>;
}) {
  const { displayTotals: value, onChangeDisplayTotals: onChange } =
    useContextFn();
  useAutoSelectValue({
    value,
    options,
    selectFirstAsDefault: autoSelectIfEmpty,
    callback: onChange,
    isSuccess: true,
  });
  const handleChange = useTransformSelectValue(onChange);
  const helperText = errorMessages['displayTotals'];
  return (
    <Select
      fullWidth
      size="small"
      value={value}
      label="Display Totals"
      options={options}
      onChange={handleChange}
      error={!!helperText}
      helperText={helperText}
    />
  );
}
